import axios from 'axios';

export default {
    methods: {
        async fletePrecioIndex(d, ok, err) {
            try {
                let r = await axios.get('flete/precio?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fletePrecioStore(d, ok, err) {
            try {
                let r = await axios.post('flete/precio', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fletePrecioUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('flete/precio/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fletePrecioShow(id, ok, err) {
            try {
                let r = await axios.get('flete/precio/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fletePrecioDestroy(id, ok, err) {
            try {
                let r = await axios.delete('flete/precio/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fletePrecioTotal(d, ok, err) {
            try {
                let r = await axios.post('flete/precio/total', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fletePrecioImportar(d, ok, err) {
            try {
                let r = await axios.post('flete/precio/importar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/flete_precio.js